import { render, staticRenderFns } from "./bannersItemData.vue?vue&type=template&id=50f296f6&scoped=true&"
import script from "./bannersItemData.vue?vue&type=script&lang=js&"
export * from "./bannersItemData.vue?vue&type=script&lang=js&"
import style0 from "./bannersItemData.vue?vue&type=style&index=0&id=50f296f6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50f296f6",
  null
  
)

export default component.exports